import axios from 'axios';
import axiosV2 from '../../utils/axiosV2';
import { GET_ERRORS } from '../actions/types'

export const getAllBooks = (page) => dispatch => {
    return axiosV2
        .get('/api/all/paperback?page=' + page)
        .then((res) => {
            //console.log(res)

            return Promise.resolve(res.data)
        }).catch((err) => {
            //console.log(err)
            return Promise.reject(err)
        })
}

export const sortAllBooks = (Name, Sort) => dispatch => {
    return axiosV2
        .get('/api/publisher/sort/paperback?Name=' + Name + '&Sort=' + Sort)
        .then((res) => {
            //console.log(res)

            return Promise.resolve(res.data)
        }).catch((err) => {
            //console.log(err)
            return Promise.reject(err)
        })
}

export const searchBook = (Name) => dispatch => {
    return axiosV2
        .get('/api/admin/search/paperback?Name=' + Name)
        .then((res) => {
            //console.log(res)

            return Promise.resolve(res.data)
        }).catch((err) => {
            //console.log(err)
            return Promise.reject(err)
        })
}

export const createBook = bookData => dispatch => {
    // V2 API expects 'id' field for updates, convert Book_ID to id if present
    const requestData = { ...bookData };
    
    // If Book_ID exists but id doesn't, convert Book_ID to id for v2 API
    if (requestData.Book_ID && !requestData.id) {
        requestData.id = requestData.Book_ID;
        delete requestData.Book_ID; // Remove Book_ID as v2 API uses 'id'
    }
    
    return axiosV2
        .post('/api/admin/paperback', requestData)
        .then(res => {
            return Promise.resolve(res.data)
        })
        .catch(err => {

            if (err.response && err.response.data != null && err.response.data.validation) {
                //console.log(err.response.data.validation);
                err = err.response.data
            } else {
                err = { "msg": "Something went wrong" }
            }
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
            return Promise.reject(err)
        });
};

export const removeBook = bookData => dispatch => {
    // V2 API expects { id: "uuid-123" } format
    const deleteData = {
        id: bookData.id || bookData.Book_ID || bookData.ID
    };
    
    return axiosV2
        .post('/api/admin/deletepaperback', deleteData)
        .then(res => {
            return Promise.resolve(res.data)
        })
        .catch(err => {

            if (err.response && err.response.data != null && err.response.data.validation) {
                //console.log(err.response.data.validation);
                err = err.response.data
            } else {
                err = { "msg": "Something went wrong" }
            }
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
            return Promise.reject(err)
        });
};

export const getBookCategory = () => dispatch => {
    return axios
        .get('api/publicationcategory')
        .then((res) => {
            //console.log(res)
            return Promise.resolve(res.data)
        }).catch((err) => {
            //console.log(err)
            return Promise.reject(err)
        })
}

export const uploadEpub = restaurantData => dispatch => {
    return axios
        .post('/api/upload/book/pdf', restaurantData, {
            headers: { 'Content-Type': 'multipart/form-data', }
        })
        .then(res => {
            return Promise.resolve(res.data)
        })
        .catch(err => {

            if (err.response.data != null && err.response.data.validation) {
                //console.log(err.response.data);
                err = err.response.data
            } else {
                err = { "msg": "Something went wrong" }
            }

            return Promise.reject(err)
        });

};

export const uploadImage = restaurantData => dispatch => {
    return axios
        .post('/api/image', restaurantData, {
            headers: { 'Content-Type': 'multipart/form-data', }
        })
        .then(res => {
            return Promise.resolve(res.data)
        })
        .catch(err => {

            if (err.response.data != null && err.response.data.validation) {
                //console.log(err.response.data);
                err = err.response.data
            } else {
                err = { "msg": "Something went wrong" }
            }

            return Promise.reject(err)
        });

};
